export default {"src":"/_next/static/media/SI.c469b280.svg","height":355,"width":512,"blurWidth":0,"blurHeight":0};